import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { serviceUnavailableError } from 'garaje/utils/catch-service-error';

export default class DesksGetStartedRoute extends Route {
  @service state;
  @service store;
  @service router;
  @service transitionConfirm;
  @service abilities;

  beforeModel() {
    if (this.abilities.cannot('visit-settings desks')) {
      this.router.transitionTo('unauthorized');
    }

    if (this.abilities.can('use generic resource')) {
      this.router.transitionTo('resources.resource-type.settings', 1);
    }

    // canVisitSettings (checked above) already validates hasDesksAccess.
    // This catches the desk-location activation state before model() runs.
    if (!this.state.isDesksActiveAtLocation) {
      // "No desk locations" can mean the load failed, not that the customer
      // has none; onboarding would tell them their setup is gone. Show the
      // outage panel instead.
      if (this.state.deskDataDegraded) {
        throw serviceUnavailableError('Desk data is currently unavailable');
      }
      this.router.transitionTo('desks.landing-page');
    }
  }

  async model() {
    const desksModel = this.modelFor('desks');
    const deskLocationId = this.state.currentLocationEnabledDesks?.id;
    if (!deskLocationId) {
      return { ...desksModel, workplaceDays: [] };
    }
    await this.store.findRecord('desk-location', deskLocationId, {
      reload: true,
      include: 'workplace-days',
    });
    const workplaceDays = this.store
      .peekAll('workplaceDay')
      .filter((day) => {
        return day.belongsTo('deskLocation').id() === deskLocationId;
      })
      .sort((a, b) => a.id - b.id);
    return { ...desksModel, workplaceDays };
  }
}
